import { useState } from 'react';
import { Card, CardTitle, CardDescription } from '@/components/ui/Card';
import { Checkbox } from '@/components/ui/Checkbox';
import { useCompanyInfo, useUpdatePaymentMethods } from '@/hooks/useSettings';
import type { PaymentMethod } from '@/types/domain';
import { CreditCard } from 'lucide-react';

const ALL_METHODS: { value: PaymentMethod; label: string; description: string }[] = [
  { value: 'cash', label: 'Cash', description: 'Tunai dengan change calculator' },
  { value: 'qris', label: 'QRIS', description: 'QR code Indonesian standard' },
  { value: 'transfer', label: 'Transfer Bank', description: 'BCA/Mandiri/BSI/dll' },
];

export function PaymentMethodsForm() {
  const { data: company, isLoading } = useCompanyInfo();
  const update = useUpdatePaymentMethods();
  const [selected, setSelected] = useState<PaymentMethod[]>([]);

  // Sync from company
  if (company && selected.length === 0 && (company.paymentMethods?.length ?? 0) > 0) {
    setSelected(company.paymentMethods);
  }

  const toggle = (method: PaymentMethod) => {
    setSelected((curr) =>
      curr.includes(method) ? curr.filter((m) => m !== method) : [...curr, method],
    );
  };

  const handleSave = async () => {
    await update.mutateAsync(selected);
  };

  const dirty =
    !!company &&
    (selected.length !== (company.paymentMethods?.length ?? 0) ||
      !selected.every((m) => company.paymentMethods?.includes(m)));

  return (
    <Card>
      <div className="flex items-start gap-3 mb-5">
        <div className="w-10 h-10 rounded bg-primary/10 text-primary flex items-center justify-center flex-shrink-0">
          <CreditCard size={18} />
        </div>
        <div>
          <CardTitle>Metode pembayaran</CardTitle>
          <CardDescription>
            Pilih metode yang diterima di POS. Minimal 1.
          </CardDescription>
        </div>
      </div>

      <div className="space-y-3">
        {ALL_METHODS.map((m) => (
          <Checkbox
            key={m.value}
            checked={selected.includes(m.value)}
            onChange={() => toggle(m.value)}
            label={m.label}
            description={m.description}
            disabled={isLoading}
          />
        ))}
      </div>

      <div className="pt-4 mt-4 border-t border-line flex justify-end">
        <button
          type="button"
          onClick={handleSave}
          disabled={!dirty || selected.length === 0 || update.isPending}
          className="btn btn-primary btn-md disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {update.isPending ? 'Menyimpan…' : 'Simpan'}
        </button>
      </div>
    </Card>
  );
}
